import {isMobile} from 'Utils/device';

// tooltip layer name
export const COMMENT_TOOLTIP_NAME_SHARP = 'fv--annot-selection-sharp-tooltip';
export const COMMENT_TOOLTIP_NAME_MARK = 'fv--annot-selection-mark-tooltip';
export const COMMENT_TOOLTIP_NAME_FONTSIZE = 'fv--annot-selection-fontszie-tooltip';
// TODO FOXIT 云编辑手机端添加选择颜色或取消弹窗
export const FW_MOBILE_TOOLTIP_NAME_SELECT_COLOR_OR_CANCEL = 'fw--annot-selection-color-or-cancel-tooltip';

// class
export const COMMENT_TOOLTIP_CLS_SHARP = 'fv--ui-annotation-selection-sharp ';
export const COMMENT_TOOLTIP_CLS_MARKUP = 'fv--ui-annotation-selection-markup fw--ui-annotation-selection-markup';
export const COMMENT_TOOLTIP_CLS_FONTSIZE = 'fv--ui-annotation-selection-fontsize  fw--ui-annotation-selection-fontsize';
// TODO FOXIT 云编辑手机端添加选择颜色或取消弹窗
export const FW_MOBILE_TOOLTIP_CLS_SELECT_COLOR_OR_CANCEL = 'fw--ui-selection-color-or-cancel-tooltip';

// button name
export const COMMENT_SHARP_COLOR_1 = 'comment-sharp-color-1';
export const COMMENT_SHARP_COLOR_2 = 'comment-sharp-color-2';
export const COMMENT_SHARP_COLOR_3 = 'comment-sharp-color-3';
export const COMMENT_SHARP_COLOR_4 = 'comment-sharp-color-4';
export const COMMENT_SHARP_COLOR_5 = 'comment-sharp-color-5';
export const COMMENT_SHARP_COLOR_MORE = 'comment-sharp-color-more';
export const COMMENT_SHARP_COLOR_MORE_TEAMS = 'comment-sharp-color-more-teams';
// button name
export const COMMENT_TEXT_MARKUP_COLOR_1 = 'comment-markup-color-1';
export const COMMENT_TEXT_MARKUP_COLOR_2 = 'comment-markup-color-2';
export const COMMENT_TEXT_MARKUP_COLOR_3 = 'comment-markup-color-3';
export const COMMENT_TEXT_MARKUP_COLOR_4 = 'comment-markup-color-4';
export const COMMENT_TEXT_MARKUP_COLOR_5 = 'comment-markup-color-5';
export const COMMENT_TEXT_MARKUP_COLOR_MORE = 'comment-markup-color-more';

export const COMMENT_TYPEWRITER_FONTSIZE_1 = 'comment-typewriter-fontsize-1';
export const COMMENT_TYPEWRITER_FONTSIZE_2 = 'comment-typewriter-fontsize-2';
//
// TODO FOXIT 云编辑手机端添加选择颜色或取消弹窗 按钮
export const FW_MOBILE_BUTTON_SELECT_COLOR = 'fw--comment-button-color';
export const FW_MOBILE_BUTTON_SELECT_CANCEL = 'fw--comment-button-cancel';

export const COMMENTS_TOOLTIP_SHORTCUT_CONTEXT_NAME = 'online-shortcut-context-comments-tooltip';

// export const COMMENTS_TOOLTIP_SHORTCUT_CONTEXT_NAME = 'online-shortcut-context-comments-tooltip';

export const COMMENTS_SELECTION_TOOLTIP_MAP = [
  COMMENT_SHARP_COLOR_1,
  COMMENT_SHARP_COLOR_2,
  COMMENT_SHARP_COLOR_3,
  COMMENT_SHARP_COLOR_4,
  COMMENT_SHARP_COLOR_5,
  COMMENT_SHARP_COLOR_MORE,
  COMMENT_TEXT_MARKUP_COLOR_1,
  COMMENT_TEXT_MARKUP_COLOR_2,
  COMMENT_TEXT_MARKUP_COLOR_3,
  COMMENT_TEXT_MARKUP_COLOR_4,
  COMMENT_TEXT_MARKUP_COLOR_5,
  COMMENT_TEXT_MARKUP_COLOR_MORE,
  COMMENT_TYPEWRITER_FONTSIZE_1,
  COMMENT_TYPEWRITER_FONTSIZE_2,
  COMMENT_SHARP_COLOR_MORE_TEAMS,
  FW_MOBILE_BUTTON_SELECT_COLOR,
  FW_MOBILE_BUTTON_SELECT_CANCEL
];
//$lineColors:('1': #00bdea, '2':#fc8a00, '3':#059f50, '4':#ea2020);
//$paddingColors:('1': #FFFF00, '2':#55B0FF, '3':#28E092, '4':#E54D0A);
const lineColors = {
  [COMMENT_SHARP_COLOR_1]: '#00BDEA',
  [COMMENT_SHARP_COLOR_2]: '#FC8A00',
  [COMMENT_SHARP_COLOR_3]: '#059F50',
  [COMMENT_SHARP_COLOR_4]: '#EA2020',
  [COMMENT_SHARP_COLOR_5]: '#6465F1',
};
const paddingColors = {
  [COMMENT_TEXT_MARKUP_COLOR_1]: '#FFFF00',
  [COMMENT_TEXT_MARKUP_COLOR_2]: '#55B0FF',
  [COMMENT_TEXT_MARKUP_COLOR_3]: '#28E092',
  [COMMENT_TEXT_MARKUP_COLOR_4]: '#E54D0A',
  [COMMENT_TEXT_MARKUP_COLOR_5]: '#6465F1',
};
const fontSizeValues = {
  [COMMENT_TYPEWRITER_FONTSIZE_1]: 1,
  [COMMENT_TYPEWRITER_FONTSIZE_2]: -1,
};
const colorOrCancel = {
  [FW_MOBILE_BUTTON_SELECT_COLOR]: "color",
  [FW_MOBILE_BUTTON_SELECT_CANCEL]: "cancel",
};
let COMMENT_SHARP_MAP_PC = {
// export const COMMENT_SHARP_MAP = {
  COMMENTS_TOOLTIP_SHORTCUT_CONTEXT_NAME,
  targetName: COMMENT_TOOLTIP_NAME_SHARP,
  targetCls: COMMENT_TOOLTIP_CLS_SHARP,
  targets: [
    {
      name: COMMENT_SHARP_COLOR_1,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle',
      clrValue: lineColors[COMMENT_SHARP_COLOR_1],
    },
    {
      name: COMMENT_SHARP_COLOR_2,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle',
      clrValue: lineColors[COMMENT_SHARP_COLOR_2],
    },
    {
      name: COMMENT_SHARP_COLOR_3,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle',
      clrValue: lineColors[COMMENT_SHARP_COLOR_3],
    },
    {
      name: COMMENT_SHARP_COLOR_4,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle',
      clrValue: lineColors[COMMENT_SHARP_COLOR_4],
    }
  ],
  more: [
    {
      name: COMMENT_SHARP_COLOR_5,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle fv__icon-popup-custom-color',
      clrValue: lineColors[COMMENT_SHARP_COLOR_5],
    },
    {
      name: COMMENT_SHARP_COLOR_MORE,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle fv__icon-popup-more-color',
      clrValue: lineColors[COMMENT_SHARP_COLOR_5],
    }
  ]
}
let COMMENT_SHARP_MAP_MOBILE = {
  COMMENTS_TOOLTIP_SHORTCUT_CONTEXT_NAME,
  targetName: COMMENT_TOOLTIP_NAME_SHARP,
  targetCls: COMMENT_TOOLTIP_CLS_SHARP,
  targets: [
    {
      name: COMMENT_SHARP_COLOR_1,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle',
      clrValue: lineColors[COMMENT_SHARP_COLOR_1],
    },
    {
      name: COMMENT_SHARP_COLOR_2,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle',
      clrValue: lineColors[COMMENT_SHARP_COLOR_2],
    },
    {
      name: COMMENT_SHARP_COLOR_3,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle',
      clrValue: lineColors[COMMENT_SHARP_COLOR_3],
    },
    {
      name: COMMENT_SHARP_COLOR_4,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle',
      clrValue: lineColors[COMMENT_SHARP_COLOR_4],
    },
    {
      name: COMMENT_SHARP_COLOR_5,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle fv__icon-popup-custom-color',
      clrValue: lineColors[COMMENT_SHARP_COLOR_5],
    }
  ],
  more: [
    {
      name: COMMENT_SHARP_COLOR_MORE,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle fv__icon-popup-more-color',
      clrValue: lineColors[COMMENT_SHARP_COLOR_5],
    }
  ]
}
export const COMMENT_SHARP_MAP = isMobile ? COMMENT_SHARP_MAP_MOBILE: COMMENT_SHARP_MAP_PC;
////$paddingColors:('1': '#FFFF00', '2':'#55B0FF', '3':'#28E092', '4':'#E54D0A');

let COMMENT_TEXT_MARKUP_MAP_PC = {
// export const COMMENT_TEXT_MARKUP_MAP = {
  COMMENTS_TOOLTIP_SHORTCUT_CONTEXT_NAME,
  targetName: COMMENT_TOOLTIP_NAME_MARK,
  targetCls: COMMENT_TOOLTIP_CLS_MARKUP,
  targets: [
    {
      name: COMMENT_TEXT_MARKUP_COLOR_1,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle',
      clrValue: paddingColors[COMMENT_TEXT_MARKUP_COLOR_1],
    },
    {
      name: COMMENT_TEXT_MARKUP_COLOR_2,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle',
      clrValue: paddingColors[COMMENT_TEXT_MARKUP_COLOR_2],
    },
    {
      name: COMMENT_TEXT_MARKUP_COLOR_3,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle',
      clrValue: paddingColors[COMMENT_TEXT_MARKUP_COLOR_3],
    },
    {
      name: COMMENT_TEXT_MARKUP_COLOR_4,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle',
      clrValue: paddingColors[COMMENT_TEXT_MARKUP_COLOR_4],
    }
  ],
  more: [
    {
      name: COMMENT_TEXT_MARKUP_COLOR_5,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle fv__icon-popup-custom-color',
      clrValue: paddingColors[COMMENT_TEXT_MARKUP_COLOR_5],
    },
    {
      name: COMMENT_TEXT_MARKUP_COLOR_MORE,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle fv__icon-popup-more-color',
      clrValue: paddingColors[COMMENT_TEXT_MARKUP_COLOR_5],
    }
  ]
}
let COMMENT_TEXT_MARKUP_MAP_MOBILE = {
  COMMENTS_TOOLTIP_SHORTCUT_CONTEXT_NAME,
  targetName: COMMENT_TOOLTIP_NAME_MARK,
  targetCls: COMMENT_TOOLTIP_CLS_MARKUP,
  targets: [
    {
      name: COMMENT_TEXT_MARKUP_COLOR_1,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle',
      clrValue: paddingColors[COMMENT_TEXT_MARKUP_COLOR_1],
    },
    {
      name: COMMENT_TEXT_MARKUP_COLOR_2,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle',
      clrValue: paddingColors[COMMENT_TEXT_MARKUP_COLOR_2],
    },
    {
      name: COMMENT_TEXT_MARKUP_COLOR_3,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle',
      clrValue: paddingColors[COMMENT_TEXT_MARKUP_COLOR_3],
    },
    {
      name: COMMENT_TEXT_MARKUP_COLOR_4,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle',
      clrValue: paddingColors[COMMENT_TEXT_MARKUP_COLOR_4],
    },
    {
      name: COMMENT_TEXT_MARKUP_COLOR_5,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle fv__icon-popup-custom-color',
      clrValue: paddingColors[COMMENT_TEXT_MARKUP_COLOR_5],
    },
  ],
  more: [
    {
      name: COMMENT_TEXT_MARKUP_COLOR_MORE,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle fv__icon-popup-more-color',
      clrValue: paddingColors[COMMENT_TEXT_MARKUP_COLOR_5],
    }
  ]
}

export const COMMENT_TEXT_MARKUP_MAP = isMobile? COMMENT_TEXT_MARKUP_MAP_MOBILE : COMMENT_TEXT_MARKUP_MAP_PC

export const COMMENT_TYPEWRITER_MAP = {
  COMMENTS_TOOLTIP_SHORTCUT_CONTEXT_NAME,
  targetName: COMMENT_TOOLTIP_NAME_FONTSIZE,
  targetCls: COMMENT_TOOLTIP_CLS_FONTSIZE,
  targets: [
    {
      name: COMMENT_TYPEWRITER_FONTSIZE_1,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle',
      text: `${isMobile ? 'phantom_online:toolbar.fwMobileDialog.fontSizeAdd' : ''}`,
      clrValue: fontSizeValues[COMMENT_TYPEWRITER_FONTSIZE_1],
    },
    {
      name: COMMENT_TYPEWRITER_FONTSIZE_2,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle',
      text: `${isMobile ? 'phantom_online:toolbar.fwMobileDialog.fontSizeReduce' : ''}`,
      clrValue: fontSizeValues[COMMENT_TYPEWRITER_FONTSIZE_2],
    }
  ],
};
export const FW_MOBILE_COMMENT_SELECT_COLOR_OR_CANCEL = {
  COMMENTS_TOOLTIP_SHORTCUT_CONTEXT_NAME,
  targetName: FW_MOBILE_TOOLTIP_NAME_SELECT_COLOR_OR_CANCEL,
  targetCls: FW_MOBILE_TOOLTIP_CLS_SELECT_COLOR_OR_CANCEL,
  targets: [
    {
      name: FW_MOBILE_BUTTON_SELECT_CANCEL,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle fw__icon-popup-cancel-color',
      text: 'phantom_online:toolbar.fwMobileDialog.cancelColor',
      clrValue: colorOrCancel[FW_MOBILE_BUTTON_SELECT_CANCEL],
    },
    {
      name: FW_MOBILE_BUTTON_SELECT_COLOR,
      title: 'phantom_online:toolbar.buttons.openLocalFile',
      icon: 'fv__icon-popup-color-circle fw__icon-popup-select-color',
      text: 'phantom_online:toolbar.fwMobileDialog.selectColor',
      clrValue: colorOrCancel[FW_MOBILE_BUTTON_SELECT_COLOR],
    }
  ],
};
